import { Controller } from "@hotwired/stimulus"
import { saveFile } from "../helpers"

export default class extends Controller {
  static targets = ["downloadAllButton", "readyButton", "code"]
  static classes = ["lightButton"]

  savedCodes = false

  copiedCodes() {
    this.savedCodes = true
    if (this.hasReadyButtonTarget) this.readyButtonTarget.classList.remove("hidden")

    if (this.hasDownloadAllButtonTarget) {
      this.downloadAllButtonTarget.className = ""
      this.downloadAllButtonTarget.classList.add(...this.lightButtonClasses)
    }
  }

  downloadCodes(event) {
    const codes = this.codeTargets.map(code => code.textContent.trim()).join("\n")
    const blob = new Blob([codes], { type: "text/plain" })
    saveFile(`${event.params.fileName}`, null, blob)
    this.copiedCodes()
  }

  warnUnsaved(event) {
    if (!this.savedCodes) {
      event.preventDefault()
      event.stopImmediatePropagation()
      if (confirm(event.params.liveWarning ? event.params.liveWarning : "Masz niezapisany kod. Na pewno chcesz opuścić stronę?")) {
        this.savedCodes = true
        Turbo.visit(event.detail.url)
      }
    }
  }
}
